<div class="row justify-content-center">
  <div class="col-6">
    <div class="row">
      <h5>{{ localizationKey('hospitalNurseSettingsTitle') | localize }}</h5>
    </div>

    <label class="w-100 my-2">
      <input
        type="checkbox"
        data-testid="nurse-2fa"
        [ngModel]="nurse2Fa"
        (ngModelChange)="onNurse2FaChange($event)"
      />
      {{ localizationKey('hospitalNurseSettings2FaCheckbox') | localize }}
    </label>

    <label class="w-100 my-2" *ngIf="feature439Released">
      <input
        type="checkbox"
        data-testid="initiate-with-device-serial"
        [ngModel]="initiateWithDeviceSerial"
        (ngModelChange)="onInitiateWithDeviceSerialChange($event)"
      />
      {{ localizationKey('hospitalNurseSettingsInitiateWithDeviceSerialCheckbox') | localize }}
    </label>

    <div class="my-2">
      <div class="row">
        <h6>{{ localizationKey('reportDeliveryNotificationSettingsTitle') | localize }}</h6>
      </div>

      <div class="row my-1">
        <div class="col-6">
          <input
            id="notifications-none"
            data-testId="report-delivery-notifications-none"
            type="radio"
            name="reportDeliveryNotification"
            [value]="'NONE'"
            [ngModel]="reportDeliveryNotification"
            (ngModelChange)="onReportDeliveryNotificationChange($event)">
          <label for="notifications-none" class="ms-1">
            {{ localizationKey('noReportDeliveryNotifications') | localize }}
          </label>
        </div>
      </div>
      <div class="row my-1">
        <div class="col-6">
          <input
            id="notifications-initiating"
            data-testId="report-delivery-notifications-initiating-nurse"
            type="radio"
            name="reportDeliveryNotification"
            [value]="'INITIATING_NURSE'"
            [ngModel]="reportDeliveryNotification"
            (ngModelChange)="onReportDeliveryNotificationChange($event)">
          <label for="notifications-initiating" class="ms-1">
            {{ localizationKey('initiatingNurseReportDeliveryNotifications') | localize }}
          </label>
        </div>
      </div>
      <div class="row my-1">
        <div class="col-6">
          <input
            id="notifications-all-nurses"
            data-testId="report-delivery-notifications-all-hospital-nurses"
            type="radio"
            name="reportDeliveryNotification"
            [value]="'ALL_HOSPITAL_NURSES'"
            [ngModel]="reportDeliveryNotification"
            (ngModelChange)="onReportDeliveryNotificationChange($event)">
          <label for="notifications-all-nurses" class="ms-1">
            {{ localizationKey('allNursesReportDeliveryNotifications') | localize }}
          </label>
        </div>
      </div>

    </div>
  </div>
</div>
